import { AlertTriangle, Lock } from 'lucide-react'

import { messages } from '@/lib/messages'

/** Widget çizilemediğinde bloğun yerinde görünen kısa durum: yetkisiz view ya da geçersiz tanım. */
export function WidgetNotice({
  kind,
  message,
}: {
  kind: 'forbidden' | 'invalid'
  message?: string
}) {
  const Icon = kind === 'forbidden' ? Lock : AlertTriangle
  return (
    <div
      role={kind === 'invalid' ? 'alert' : undefined}
      className="border-border text-muted-foreground flex items-center gap-2 rounded-md border border-dashed p-3 text-sm"
    >
      <Icon className="size-4 shrink-0" aria-hidden="true" />
      <span>{kind === 'forbidden' ? messages.documents.editor.forbiddenView : message}</span>
    </div>
  )
}
